
/**
 * 현재 사용자의 투표 상태
 */
export type ReviewDetailAllOfTwoUserVote = typeof ReviewDetailAllOfTwoUserVote[keyof typeof ReviewDetailAllOfTwoUserVote];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewDetailAllOfTwoUserVote = {
  HELPFUL: 'HELPFUL',
  UNHELPFUL: 'UNHELPFUL',
  NONE: 'NONE',
} as const;
